import { ReactComponent as SquareCheckSVG } from "./svg/icon_SquareCheck.svg";

export const IconSquareCheck = () => {
  return <SquareCheckSVG />;
};
